import { lazy } from 'react';
export { IDEAS_AND_COMPANIES_ROUTES } from './routes';
export { default as routes } from './routes';

export const IdeasAndOpportunitiesFeature = lazy(() => import('./pages/SivaContractsFeature'));
